import * as AuthProxy from "../../security/AuthProxy";
const CryptoJs = require('crypto-js');

export function getTenantIds()
{
    return fetch(`./portunus/tenantId`,{
        headers: {
            'session-id': AuthProxy.getSessionId() as string,
            'authtype': AuthProxy.getAuthType() as string
        }
    });
}
